"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _draw = require("./draw");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FADE_TIME = 750;

var LoadImage = /*#__PURE__*/function () {
  function LoadImage(src, onLoaded) {
    _classCallCheck(this, LoadImage);

    this.img = new Image();
    this.onLoaded = onLoaded;
    this.loadComplete = this.loadComplete.bind(this);
    this.img.addEventListener('load', this.loadComplete, false);
    this.img.src = src;
  }

  _createClass(LoadImage, [{
    key: "loadComplete",
    value: function loadComplete() {
      if (this.onLoaded) this.onLoaded(this.img);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.img.removeEventListener('load', this.loadComplete);
    }
  }]);

  return LoadImage;
}();

var Animation = /*#__PURE__*/function () {
  function Animation() {
    _classCallCheck(this, Animation);

    this.time = 0;
    this.accumTimeout = 0;
    this.accumImage = 0;
    this.image = null;
    this.next = null;
    this.commands = [];
    this.resize = this.resize.bind(this);
    this.update = this.update.bind(this);
    this.start();
  }

  _createClass(Animation, [{
    key: "setup",
    value: function setup(canvas) {
      this.canvas = canvas;
      this.context = canvas.getContext('2d');
      this.resize();
      this.request = requestAnimationFrame(this.update);
    }
  }, {
    key: "start",
    value: function start() {
      this.startListeners();
    }
  }, {
    key: "update",
    value: function update(time) {
      var delta = time - this.time;
      this.time = time;
      this.accumTimeout += delta;
      this.accumImage += delta;

      if (this.image) {
        var type = this.getType();
        (0, _draw.draw)(this.context, this.size, this.image, this.accumImage, type, this.data.speed);
      }

      if (this.accumTimeout < FADE_TIME) {
        var opacity = this.accumTimeout / FADE_TIME;
        (0, _draw.fade)(this.context, this.size, opacity);
      } else if (this.accumTimeout < FADE_TIME * 2) {
        var _opacity = 1 - (this.accumTimeout - FADE_TIME) / FADE_TIME;

        (0, _draw.fade)(this.context, this.size, _opacity);
      }

      this.request = requestAnimationFrame(this.update);
    }
  }, {
    key: "getType",
    value: function getType() {
      if (!this.data.responsive) return this.data.type;
      var min = this.data.type;

      var _iterator = _createForOfIteratorHelper(this.data.responsive),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              breakpoint = _step$value[0],
              type = _step$value[1];

          if (this.canvas.width > breakpoint) return min;
          min = type;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return min;
    }
  }, {
    key: "startListeners",
    value: function startListeners() {
      window.addEventListener('resize', this.resize, false);
    }
  }, {
    key: "stopListeners",
    value: function stopListeners() {
      window.removeEventListener('resize', this.resize);
    }
  }, {
    key: "resize",
    value: function resize() {
      var _this$canvas$getBound = this.canvas.getBoundingClientRect(),
          width = _this$canvas$getBound.width,
          height = _this$canvas$getBound.height;

      this.canvas.width = width;
      this.canvas.height = height;
      this.size = {
        width: width,
        height: height
      };
    }
  }, {
    key: "setSize",
    value: function setSize(size) {
      this.size = size;
    }
  }, {
    key: "setImage",
    value: function setImage(data, onFadeIn, onFadeOut) {
      var _this = this;

      var imageData = Object.assign({
        type: 3,
        speed: 0.3,
        responsive: [[600, 1]]
      }, data);
      if (imageData.responsive) imageData.responsive.sort(function (_ref, _ref2) {
        var _ref3 = _slicedToArray(_ref, 1),
            b1 = _ref3[0];

        var _ref4 = _slicedToArray(_ref2, 1),
            b2 = _ref4[0];

        return b2 - b1;
      });
      if (this.loadingImage) this.loadingImage.destroy();
      clearTimeout(this.fadeInTimeout);
      this.loadingImage = new LoadImage(imageData.image, function (img) {
        return _this.showImage(imageData, img, onFadeIn, onFadeOut);
      });
    }
  }, {
    key: "showImage",
    value: function showImage(data, image, onFadeIn, onFadeOut) {
      var _this2 = this;

      this.accumTimeout = 0;
      if (onFadeOut) onFadeOut(data);
      this.fadeInTimeout = setTimeout(function () {
        _this2.data = data;
        _this2.image = image;
        _this2.accumImage = 0;
        if (onFadeIn) onFadeIn(data);
      }, FADE_TIME);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListeners();
      clearTimeout(this.fadeInTimeout);
      cancelAnimationFrame(this.request);
    }
  }]);

  return Animation;
}();

var _default = Animation;
exports["default"] = _default;